import styled from 'styled-components'
import { Input } from 'antd'
import SVG from 'core/components/svg'
import { font, greys } from 'assets/themes/theme-default'
import { Form } from 'core/components/ui'

import { isMobile } from 'react-device-detect'

const InputGroup = Input.Group

export const MapWrapperContainer = styled.div`
  border: 1px solid ${props => props.theme.colors.color1.bg};
  padding: 5px;
  height: ${isMobile ? '400px' : '856px'};
  margin-top: ${isMobile ? '0' : '102px'};
`
export const StyledPageLoading = styled.div`
  margin-top: ${isMobile ? '0' : '102px'};
  height: ${isMobile ? '400px' : '856px'};
  width: 100%;
  background-color: white;
  position: absolute;
  z-index: 5;
  left: 0;
`

export const TitleSpan = styled.span`
  font-weight: ${font.weight.base};
`

export const StyledInputGroup = styled(InputGroup)`
  vertical-align: top;
  button.ant-btn {
    padding: 0 !important;
    width: 15%;
    height: 39px !important;
    line-height: 48px;
    box-shadow: none;
    border-color: ${greys.light1} !important;
    &:after {
      display: none;
    }
    &:first-child {
      border-right: none;
      border-radius: 6px 0 0 6px !important;
    }
    &:last-child {
      border-left: none;
      border-radius: 0 6px 6px 0 !important;
    }
  }
`
export const StyledZipCodeInput = styled(Form.Item)`
  &&& {
    font-size: ${font.size.lg};
    color: ${greys.dark1};
    vertical-align: top;
    .ant-input {
      // border-radius: 6px 0 0 6px !important;
      height: 39px !important;
      border-width: 1px 0;
      vertical-align: top;
      border-right: none;
      border-radius: none;
      transition: 0s;
      ${isMobile && 'padding:12px 0;'}
      &:focus {
        outline: 3px transparent solid;
      }
    }

    .ant-input-affix-wrapper .ant-input:not(:first-child) {
      padding-left: ${isMobile ? '32px' : '45px'};
    }
    .ant-input-prefix {
      .anticon svg {
        fill: ${props => props.theme.colors.color1.bg};
      }
    }
    .ant-form-explain {
      font-size: ${font.size.sm};
    }
    .ant-input-group-addon {
      background: none;
      .ant-btn-primary {
        background: none;
        border-left: none;
        color: ${props => props.theme.colors.color1.bg};
        height: 39px !important;
        box-shadow: none;
        border-radius: 0 6px 6px 0 !important;
        padding: 9px 15px !important;
      }
    }
    * {
      border-color: ${greys.light1} !important;
      border-radius: 5px;
    }
  }
`
export const InputIcon = styled(SVG)`
  width: 20px;
  height: 20px;
  fill: ${props => props.theme.colors.color1.bg};
`

export const PointOfSalesTitle = styled.h4`
  color: ${greys.dark1};
  font-size: ${font.size.lg};
`
export const PointOfSalesDatas = styled.div`
  color: ${greys.dark3};
  font-size: ${font.size.base};
  margin: 0;
  width: 100%;
  a {
    color: ${props => props.theme.colors.color1.bg};
  }
`
export const PointOfSalesDatasWrapper = styled.div`
  margin: 10px 0;
`

export const DistributorNumber = styled.span`
  font-weight: ${font.weight.bold};
  color: ${props => props.theme.colors.color1.bg};
`
